import { V1DashboardResult } from "~/types/interfaces/catalogDashboards";
import { apiMutate } from "~/utils/apiClient";

const { VITE_CATALOG_API } = import.meta.env;

const dashboardUrl = (datasetId: string, dashboardId: string) =>
  `${VITE_CATALOG_API}/v1/datasets/${datasetId}/dashboards/${dashboardId}`;

export interface DashboardUpdate {
  displayName?: string;
  description?: string;
}

// Only the fields present are sent; the endpoint rejects an empty body.
export const updateDashboard = (datasetId: string, dashboardId: string, update: DashboardUpdate) =>
  apiMutate<V1DashboardResult>(dashboardUrl(datasetId, dashboardId), "PATCH", {
    display_name: update.displayName,
    description: update.description,
  });

export const removeDashboard = (datasetId: string, dashboardId: string) =>
  apiMutate(dashboardUrl(datasetId, dashboardId), "DELETE", undefined, {
    expects204: true,
  });
